
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {CSSTransitionGroup} from 'react-transition-group'

export default class Overlay extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    animationDuration: PropTypes.number
  }

  static defaultProps = {
    animationDuration: 200
  }

  render() {
    const {children, visible, animationDuration} = this.props
    return (
      <div className='overlay'>
        <CSSTransitionGroup
          transitionName='overlay'
          transitionEnterTimeout={animationDuration}
          transitionLeaveTimeout={animationDuration}
        >
          {visible ? <div className='overlay_body' /> : null}
        </CSSTransitionGroup>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Overlay/index.js